const model = {
  LoginInfo: {},
  CardUser: {},
  CardInfo: {},
  DebitCardInfo: {},
  PlanInfo: {},
  quantity: {},
  quantitylist: {},
  planItemMaplist: {}
}
export default model;